import { useDispatch, useSelector, shallowEqual } from "react-redux";
import React, { memo, useCallback } from "react";
import { Grid } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import { getGlobalInvoice } from "redux/actions/globalInvoices/globalInvoicesAction";
import { GlobalInvoicesSelectStation } from "./GlobalInvoicesSelectStation";
import { GlobalInvoicesSelectStartDate } from "./GlobalInvoicesSelectStartDate";
import { GlobalInvoicesSelectEndDate } from "./GlobalInvoicesSelectEndDate";
import { useSearch } from "hooks/useSearch";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

const selectStation = (state) => state.globalInvoices.station;
const selectStartDate = (state) => state.globalInvoices.startDate;
const selectEndDate = (state) => state.globalInvoices.endDate;
const selectLoadingGlobalInvoices = (state) =>
  state.search.isLoadingComp?.loadingGlobalInvoices;

export const GlobalInvoicesInputs = memo(() => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();

  const station = useSelector(selectStation, shallowEqual);
  const startDate = useSelector(selectStartDate, shallowEqual);
  const endDate = useSelector(selectEndDate, shallowEqual);
  const loadingGlobalInvoices = useSelector(
    selectLoadingGlobalInvoices,
    shallowEqual,
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!station?.id) return setSnackbar("Selecciona una Planta");
      dispatch(getGlobalInvoice(station, startDate, endDate));
    },
    [station, startDate, endDate],
  );

  return (
    <>
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          padding: 4,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3} style={style}>
            <GlobalInvoicesSelectStartDate />
          </Grid>

          <Grid item xs={12} sm={3} style={style}>
            <GlobalInvoicesSelectEndDate />
          </Grid>

          <Grid item xs={12} sm={5} style={style}>
            <GlobalInvoicesSelectStation />
          </Grid>

          <Grid
            item
            xs={12}
            sm={1}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <RegularButton
              color="info"
              onClick={handleSubmit}
              fullWidth
              loading={loadingGlobalInvoices}
            >
              buscar
            </RegularButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
});
